// Карточка морского рубежа: чей он и на каком основании.
//
// Зачем. Свойства линии приезжали с сервера с самого начала, а показать их было
// негде — и вопрос «откуда взялась вот эта линия» решался запросом к базе (бой
// 29.08.2026: владелец обвёл линию на скриншоте и спросил, чья она). Линия на
// карте, которую нельзя назвать, — та же безымянная краска, ради которой
// собирали единую легенду.
//
// Два состояния, как у карточки землетрясения: читалка при наведении (прозрачна
// для мыши — наползая на курсор, она уводила бы его с линии и гасила сама себя)
// и закреплённая кликом, с крестиком.
import { MapCallout } from './MapCallout'
import { eezLineLabel, eezTypeLabel, type EezLineProps } from './eez'
import { useT } from '../i18n'

interface Props {
  anchor: { lng: number; lat: number }
  props: EezLineProps & { override_note?: string | null }
  pinned?: boolean
  onClose: () => void
}

export function EezCard({ anchor, props, pinned = false, onClose }: Props) {
  const t = useT()
  const title = eezLineLabel(props) || t('eez.card.title')
  const type = eezTypeLabel(props.line_type)

  return (
    <MapCallout anchor={anchor} width={288} pinned={pinned}>
      <div className="flex items-start justify-between gap-2">
        <div className="text-sm font-semibold text-foam">{title}</div>
        {pinned && (
          <button
            type="button"
            onClick={onClose}
            aria-label={t('common.close')}
            className="-mr-1 -mt-1 rounded-md px-2 py-0.5 text-lg leading-none text-mist transition-colors hover:bg-haze hover:text-foam"
          >
            ×
          </button>
        )}
      </div>

      {type && (
        <div className="mt-1 text-[11px] leading-snug text-mist">
          <span className="text-faint">{t('eez.card.type')}: </span>
          {type}
        </div>
      )}

      {/* Основание — ДОКУМЕНТ, и он показывается как есть, по-английски: это
          данные, а не интерфейс, и переводить чужую ноту нам нечем. Именно
          здесь и виден настоящий ответ на вопрос «откуда линия»: у курильского
          контура тут стояла нота Японии в ООН от 25.02.2002. */}
      {props.source && (
        <div className="mt-1.5 text-[11px] leading-snug text-mist">
          <span className="text-faint">{t('eez.card.basis')}: </span>
          {props.source}
          {props.doc_date && <span className="text-faint"> · {props.doc_date}</span>}
        </div>
      )}

      {/* Строка, отличающаяся от источника, БЕЗ пометки читается как
          утверждение источника. */}
      {props.override_note && (
        <div className="mt-2 rounded-lg border border-hull px-2.5 py-1 text-[11px] leading-snug text-faint">
          {t('eez.card.edited')}: {props.override_note}
        </div>
      )}
    </MapCallout>
  )
}
